module.exports = __webpack_public_path__ + "static/team4-47647e4b9ed93f0c96a5d6bbf6fca2fc.jpg";